import router from "@/routes/router";
import { http } from "@/config/http";
import _ from "lodash";

const namespaced = true;

const getDefaultState = () => {
    return {
    };
};

const state = {
    client_upload_progress: 0,
    user_upload_progress: 0,
    claim_upload_progress: 0,
    document_upload_progress: 0,
    tax_native_file_progress: 0,
    client_tax_center_upload_progress: 0,
    cs_upadte_str: "",
    tr_upadte_str: ""
};

const getters = {

};

const mutations = {
    setFormErrors(state, data) {
        state.errors = [];
        if (data) {
            state.errors = data.details;
        }
    },
    updateProgress(state, data) {
        state.client_upload_progress = data;
    },
    updateUserUploadProgress(state, data) {
        state.user_upload_progress = data;
    },
    updateClaimUploadProgress(state, data) {
        state.claim_upload_progress = data;
    },
    updateTaxNativeFileProgress(state, data) {
        state.tax_native_file_progress = data;
    },
    updateDocumentUploadProgress(state, data) {
        state.document_upload_progress = data;
    }
};

const actions = {
    async getUserClients({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Users/" + data.user_id + "/clients")
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getClientsClaims({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/FindByClient/" + data.client_id + "")
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllClientsClaims({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/FindByClient/" + data.client_id + "")
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getClaimProjects({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Projects/FindByClaim/" + data.claim_id + "")
                .then(response => {
                    if (response.data.error) {
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.error,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    } else {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async createNewClaimProject({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Projects/" + data.claim_id + "", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async loadCheckList({ commit }, data) {
        return new Promise((resolve, reject) => {

            http
                .get("Documents/DocumentTypes")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllClaimDocuments({ commit }, data) {
        return new Promise((resolve, reject) => {

            http
                .get("Documents/ClaimDocuments/" + data.claim_id + "")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllClaimDocumentsWithArchive({ commit }, data) {
        return new Promise((resolve, reject) => {

            http
                .get("Documents/ClaimDocuments/all/" + data.claim_id + "")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async submitClaimDocuments({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Documents/ClaimDocuments/Update/" + data.claim_id + "", data.body_data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async sendDocumentAddEmail({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Documents/ClaimDocuments/DocumentClientEmail/" + data.claim_id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async rejectClaimDocuments({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Documents/ClaimDocuments/reject/" + data.claimDocId + "", data.body_data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async excelFileRead({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .post("ClientsUploads/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        commit('updateProgress', progress);

                    }.bind(this)
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async confirmFileUpload({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("ClientsUploads/confirm")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async excelFileReadUsers({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .post("UserUploads/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        commit('updateUserUploadProgress', progress);

                    }.bind(this)
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async confirmFileUploadUsers({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("UserUploads/confirm")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async excelFileReadClaims({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimUploads/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        commit('updateClaimUploadProgress', progress);

                    }.bind(this)
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async confirmFileUploadClaims({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimUploads/confirm")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async excelFileReadClientTaxCenters({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .post("TaxCenterUploads/upload", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        commit('updateClaimUploadProgress', progress);

                    }.bind(this)
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async confirmFileUploadClientTaxCenters({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("TaxCenterUploads/confirm")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async documentRead({ commit }, params) {

        let apiToken = "Bearer " + localStorage.getItem("superbos_admin_access_token");
        let xhr = new XMLHttpRequest();
        xhr.open("POST", process.env.VUE_APP_API_ENDPOINT + '/Documents/uploadDocument');
        xhr.setRequestHeader("Authorization", apiToken);

        var formData = new FormData();

        var file = new Blob([
            params.uploadFile
        ], { type: 'application/octet-stream' });

        formData.append('DocumentTypeId', params.documentTypeId);
        formData.append('ClientId', params.clientId);
        formData.append('ClaimId', params.claimId);
        formData.append('File', file, params.uploadFile.name);

        return new Promise((resolve, reject) => {
            xhr.onreadystatechange = function () {
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    resolve(JSON.parse(xhr.responseText));
                }
            }
            xhr.send(formData);
        });
        
    },
    async confirmDocumentUpload({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("Documents/confirm")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    ////
    async getAllClients({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("Users/GetClientsAll")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllClaims({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllPinnedClaims({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("Users/allPinnedClaimsByAnalyst")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllClientsTaxCenters({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("TaxCenterUploads")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllUsers({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("Users")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async tooglePinStatus({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/TogglePinStatus/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async setToGovernmentClaim({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/setToGovernment/" + data.id + "")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async setToAccountantClaim({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/setToAccountant/" + data.id + "")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async setToInprogessClaim({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/SetToInprogress/" + data.id + "")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },

    async setToAssignedClaim({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/SetToAssigned/" + data.id + "")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },

    async setToNoClaim({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/SetToNoClaim/" + data.id + "")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },

    async userUploadLastModified({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("UserUploads/last_modified")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async claimUploadLastModified({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimUploads/last_modified")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async taxCenterUploadLastModified({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("TaxCenterUploads/last_modified")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllClaimsNotifications({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("Notifications/get_all_notifications_by_analyst")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getClaimsNotifications({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .get("Notifications/get_notifications/" + formData.claim_id + " ")
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllPendingDocTypes({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Documents/ClaimDocuments/pendingUpload/" + data.claim_id + " ")
                .then(response => {
                    if (response.data.success) {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async tagClaimDocumentTypes({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Documents/ClaimDocuments/tag", data, { headers: { 'Content-Type': 'multipart/form-data' } })
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async extractFinancialsData({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/ExtractFinancials/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async generateT2TaxFileData({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/GenerateAndUploadT2TaxFile/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getExtractedFinancialsData({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/GetExtractedFinancials/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getCostSheetLink({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Onedrive/CostSheet/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getExploreFileLink({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Onedrive/ExploreView/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getTechnicalReportLink({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Onedrive/TechnicalReport/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async publishAllProjects({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/SyncProjectsToDocuments/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async uploadTaxProgramNativeFile({ commit }, formData) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/UploadTaxDocument/" + formData.get('claim_id') + "", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data"
                    },
                    onUploadProgress: function (progressEvent) {
                        let progress = Math.round(
                            (progressEvent.loaded * 100) / progressEvent.total
                        );
                        commit('updateTaxNativeFileProgress', progress);

                    }.bind(this)
                })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async setClaimIsReadyForView({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/ReadyForReview", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async sendReadyToReviewEmail({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/ReadyForReviewEmailSend/" + data.claim_id + "")
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async changeIndustryType({ commit }, data) {
        return new Promise((resolve, reject) => {
            console.log("changeIndustryType data: " + JSON.stringify(data));
            http
                .post("ClaimRecords/SetIndustry", JSON.stringify(data))
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateClaimProject({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Projects/Update/" + data.id + "", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async bosExportFile({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimUploads/export_claim", {
                    responseType: 'blob',
                })
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateIsAdmin({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Users/updateIsAdmin/" + data.id + "", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateIsActive({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Users/updateIsActive/" + data.id + "", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getClaimRecordById({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/GetById/" + data.claim_id + "", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async produceMergedPdf({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/ProduceMergedPdf", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateClaimType({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/UpdateClaimType/" + data.claimId + "", data)
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getClaimUserDetails({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/GetById/" + data.claim_id + "", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async proxyConstSheetInject({ commit }, data) {
        return new Promise((resolve, reject) => {
            console.log("proxyConstSheetInject data: " + JSON.stringify(data));
            http
                .post("ClaimRecords/ProxyCostsheetInjection", JSON.stringify(data))
                .then(response => {
                    if (response.data.success) {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getFilteredClaims({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Users/filterAllClaims", data)
                .then(response => {
                    if (response.data.success) {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getFicicalYearDropdown({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("Users/getFicicalYearDropdown", data)
                .then(response => {
                    if (response.data.success) {
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async clientsFilterByFye({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("Users/clientsFilterByFye", data)
                .then(response => {
                    if (response.data.success) {

                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateClaimStatusWhenPublish({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/UpdateClaimStatusWhenPublish/" + data.claim_id + "", data)
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAllTaxCenters({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .get("TaxCenter/GetAll", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateTaxCenter({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/UpdateTaxCenter/" + data.claimId + "", data)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async updateAccountantForClaimRecord({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .put("ClaimRecords/updateAccountant/", data)
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    resolve(error.response);
                });
        });
    },
    async getAccountants({ commit }) {
        return new Promise((resolve, reject) => {
            http
                .get("Accountants/")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getAllDocuments({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .get("Documents?clietnId=" + obj.clientId + "&claimId=" + obj.claimId + "&withDeletedFiles=" + obj.withDeletedFiles + "&isShowSelected=" + obj.isShowSelected)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async uploadDocument({ commit }, params) {
        let apiToken = "Bearer " + localStorage.getItem("superbos_admin_access_token");
        let xhr = new XMLHttpRequest();
        xhr.open("POST", process.env.VUE_APP_API_ENDPOINT + '/Documents/upload');
        xhr.setRequestHeader("Authorization", apiToken);

        var formData = new FormData();

        var file = new Blob([
            params.uploadFile
        ], { type: 'application/octet-stream' });

        formData.append('UploadPath', params.uploadPath);
        formData.append('IsOverride', params.isOverride);
        formData.append('File', file, params.uploadFile.name);

        xhr.upload.addEventListener("progress", ({ loaded, total }) => {
            let fileLoaded = Math.floor((loaded / total) * 100);
            let fileTotal = Math.floor(total / 1000);
            if (params.callBackProgress) {
                params.callBackProgress(fileLoaded, fileTotal);
            }
        });
        if (params.uploadFileCallBackStart) {
            xhr.addEventListener('loadstart', params.uploadFileCallBackStart);
        }

        if (params.uploadFileCallBackFinish) {
            xhr.addEventListener('loadend', params.uploadFileCallBackFinish);
        }

        let resultPromise = new Promise((resolve, reject) => {
            xhr.onreadystatechange = function () {
                if (xhr.readyState == XMLHttpRequest.DONE) {
                    resolve(JSON.parse(xhr.responseText));
                }
            }
        });
        xhr.send(formData);

        return resultPromise;
    },
    async unDeleteDocument({ commit }, params) {
        return new Promise((resolve, reject) => {
            http
                .post("Documents/unDelete", params)
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async deleteDocumentPermanently({ commit }, params) {
        return new Promise((resolve, reject) => {
            http
                .delete("Documents/permanently", { data: params })
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async deleteDocument({ commit }, params) {
        return new Promise((resolve, reject) => {
            http
                .delete("Documents", { data: params })
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async renameDocument({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .post("Documents/rename", obj)
                .then(response => {
                    if (response.data.success) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async checkDocumentExists({ commit }, key) {
        return new Promise((resolve, reject) => {
            http
                .post("Documents/checkExists", { key: key })
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getClaimsForReview({ commit }) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/getClaimsForReview")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getDocumentsForReviewByClaim({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .post("users/getDocumentsForReviewByClaim", obj)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getDocumentsForReview({ commit }, claimId) {
        return new Promise((resolve, reject) => {
            http
                .get("documents/getDocumentsForReview?сlaimId=" + claimId)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getS3DownloadLink({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .post("documents/getS3DownloadLink", obj)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async reviewSaveChanges({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .post("documents/reviewSaveChanges", obj)
                .then(response => {
                    if (response && response.data.success.status == true) {
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }

                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async reviewActionDocumentRequest({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .post("documents/reviewActionDocument", obj)
                .then(response => {
                    commit(
                        "showAlert",
                        {
                            title: "Success!",
                            msg: response.data.success.message,
                            type: "success",
                            position: "centerTop"
                        },
                        { root: true }
                    );
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getSharingLink({ commit }, obj) {
        return new Promise((resolve, reject) => {
            http
                .post("documents/getSharingLink", obj)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getClaimReviewInfoRequest({ commit }, claimId) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/getClaimReviewInfo?claimId=" + claimId)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getReviewWorkflows({ commit } ) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/getReviewWorkflows")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async deleteReviewWorkflow({ commit }, id ) {
        return new Promise((resolve, reject) => {
            http
                .delete("ClaimRecords/deleteReviewWorkflow", { data: {id: id} })
                .then(response => {
                    if(response.data.success.status){
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }else{
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.success.message,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async createReviewWorkflow({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/createReviewWorkflow", data)
                .then(response => {
                    if(response.data.success.status){
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }else{
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.success.message,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async setWorkflowUser({ commit }, data) {
        return new Promise((resolve, reject) => {
            http
                .post("ClaimRecords/setWorkflowUser", data)
                .then(response => {
                    if(response.data.success.status){
                        commit(
                            "showAlert",
                            {
                                title: "Success!",
                                msg: response.data.success.message,
                                type: "success",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }else{
                        commit(
                            "showAlert",
                            {
                                title: "Error!",
                                msg: response.data.success.message,
                                type: "error",
                                position: "centerTop"
                            },
                            { root: true }
                        );
                    }
                    
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getWorkflowUser({ commit }) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/getWorkflowUser")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async deleteWorkflowUserRequest({ commit }, id) {
        return new Promise((resolve, reject) => {
            http
                .delete("ClaimRecords/deleteWorkflowUser", { data: {id: id}})
                .then(response => {
                    commit(
                        "showAlert",
                        {
                            title: "Success!",
                            msg: response.data.success.message,
                            type: "success",
                            position: "centerTop"
                        },
                        { root: true }
                    );
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async isUserHasReviewWorkflow({ commit }, id) {
        return new Promise((resolve, reject) => {
            http
                .get("ClaimRecords/isUserHasReviewWorkflow?claimId=" + id)
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
    async getApplicationVersion({ commit }) {
        return new Promise((resolve, reject) => {
            http
                .get("Version")
                .then(response => {
                    resolve(response);
                })
                .catch(error => {
                    commit("handleExceptions", error, { root: true });
                    reject(error.response);
                });
        });
    },
};

export default {
    namespaced,
    state,
    getters,
    actions,
    mutations
};
